import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { PolicyService } from 'gw-capability-policy';
import _ from 'lodash';
import { Icon, ModalNextContext } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useTranslator } from '@jutro/locale';
import { LoaderExt } from 'gw-components-platform-react';
import { withRouter } from 'react-router-dom';
import {
    ViewModelServiceContext,
    withViewModelService,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import { publish, unsubscribeAll } from '@jutro/events';
import messages from './UserAdministrationPage.messages';
import metadata from './UserAdministrationPage.metadata.json5';
import styles from './UserAdministrationPage.module.scss';
import UserAdminDetails from './UserAdminDetails/UserAdminDetails';
import AddNewUser from './AddNewUser/AddNewUser';
import usecpmiAnalytics from '../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

import { Button } from '@jutro/legacy/components';

import { Link } from '@jutro/router';

function UserAdministrationPage(props) {
    const {
        history: {
            location: { state },
        },
        history,
    } = props;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const auth = useAuthentication();
    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const [addUser, setAddUser] = useState(false);
    const [usersListData, setUsersListData] = useState(null);
    const [userDataVm, updateUserDataVm] = useState({});
    const modalNext = useContext(ModalNextContext);
    const [trackPageView, trackEvent] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [addUserVM, setAddUserVM] = useState({});
    const [isUserValid, setIsUserValid] = useState(false);
    const [notificationList, setNotificationList] = useState([]);
    const [disableLossRunSubscription, setDisableLossRunSubscription] = useState(false);
    const [allAccountListCurrentUser,setAllAccountListCurrentUser] = useState([]);
   

    // useEffect(() => {
    //     unsubscribeAll();
    //     trackPageView('User Administration', '/user-administration');
    //     publish('tracking', 'event', {
    //         eventCategory: 'User Administration',
    //         eventAction: 'User Administration Details',
    //         eventLabel: '',
    //     });
    // }, []);

    
    useEffect(() => {
            trackGAPageView('/user-administration', 'User Administration');
    },[])

    const getPublishedNotifications = useCallback(() =>{
        EnrollmentService.getPublishedNotifications(authHeader).then((result) => {
            setNotificationList(result);
        }).catch(() => {
            
        });
        // setNotificationList(optInsData);
    },[authHeader]);

    const getActivePolicyForLossRunSubscription = useCallback(() =>{
        PolicyService.getAllAvailableAccountPolicySummaries_Ext(authHeader).then((policyData) => {
            if(policyData){
                let showFlag=0;
                for (let i = 0; i < policyData.length; i++) {
                    if (policyData[i].displayStatus === "In Force" || policyData[i].displayStatus === "Scheduled" || policyData[i].displayStatus === "Pending Cancellation") {                        
                        showFlag++;
                        break;
                    
                    }
                }
                if (showFlag === 0) {
                    setDisableLossRunSubscription(true);
                }
            }
        }).catch(() => {
            
        });
    },[authHeader]);

    useEffect(() => {
        setLoadingState(true);
        getActivePolicyForLossRunSubscription();
        getPublishedNotifications();
        // getAllAccountsforCurrentUser()
        EnrollmentService.getAuthorizedUsers(auth.userInfo.email, authHeader)
            .then((result) => {
                const uservm = viewModelService.create(
                    result,
                    'pc',
                    'edge.uaaoperations.dto.ScimUserDTO'
                );
                updateUserDataVm(uservm);
            })
           
            .finally(() => {
                setLoadingState(false);
            });
    }, [viewModelService, usersListData, setLoadingState, auth.userInfo.email, authHeader, getActivePolicyForLossRunSubscription, getPublishedNotifications]);


    const handleAddNewUser = useCallback(() => {
       
        trackEvent('Add New User', '/adduser');
        return history.push({
            pathname: `/adduser`,

        });
    },[history,userDataVm]);


    const getUserEmail = useCallback(
        rowData => {
            return rowData.userName;

        },
        [usersListData]
    );

   

    const renderAllAccounts = useCallback(()=>{
        EnrollmentService.getUser(auth.userInfo.email,authHeader)
        // eslint-disable-next-line no-shadow
        .then((userInfo)=>{
            // rowData.allAccountListCurrentUser = userInfo.accountInformation;
            // Logic for invoiceStreams Access
                for(let i = 0;i < userInfo.accountInformation.length; i ++)
                {
                    userInfo.accountInformation[i].invoiceStreamCount = userInfo.accountInformation[i].invoiceStreams.length;
                    userInfo.accountInformation[i].actualInvoiceSteamArray=userInfo?.accountInformation[i]?.invoiceStreams
                    const b =[];
                    // userInfo.accountInformation[i].invoiceStreams1 =[];
                    const result  =userInfo.roles.filter((o)=>o.access === userInfo.accountInformation[i].accountNumber);
                    
                    if(result.length !==0){
                        const streamResult = result.reduce((catsSoFar, { access, description }) => {
                            if (!catsSoFar[access]) catsSoFar[access] = [];
                            catsSoFar[access].push(description);
                            return catsSoFar;
                        }, {});
                        const gArray = Object.entries(streamResult);
                    
                        // eslint-disable-next-line array-callback-return
                        // userInfo?.accountInformation[i]?.invoiceStreams.map((k)=>{
                        //     const v =k.replace(/\s/g, '');
                        //     const resultFilter = gArray[0][1].includes(v);
                        //     if(resultFilter===false){
                        //         delete userInfo.accountInformation[i].invoiceStreams[k] 
                        //     }
                        //     else{ 
                        //         b.push(k);  
                        //     }
                        // })         

                        // eslint-disable-next-line guard-for-in
                        for (const inv in userInfo?.accountInformation[i]?.invoiceStreamMap) {
                            const invName = userInfo?.accountInformation[i]?.invoiceStreamMap[inv];
                            const resultFilter = gArray[0][1].includes(inv);
                            if(resultFilter===true){
                                b.push(invName); 
                            }
                        }                                   
                         
                    }
                    userInfo.accountInformation[i].invoiceStreams =[];
                    userInfo.accountInformation[i].invoiceStreams = b;
                    userInfo.accountInformation[i].accessTrueMultiInvoiceCount =userInfo.accountInformation[i].invoiceStreams.length;
                }
                
                // Logic for invoiceStreams Access
                // eslint-disable-next-line array-callback-return
                userInfo.accountInformation.map((item)=>{
                    item.buttonText = "Add Account"
                })

                setAllAccountListCurrentUser(userInfo.accountInformation);
                
            })
    },[auth.userInfo.email, authHeader])
    
    useEffect(() => {
        
        renderAllAccounts()
    }, [renderAllAccounts])
  

    const getDetails = useCallback(
        (rowData) => {
            rowData.allAccountListCurrentUser = allAccountListCurrentUser;
            const getHolderCertificate = () => {        
                return history.push({
                    pathname: '/admin-user-details',
                    state: {
                        data: rowData,
                        disableLossRunSubscription,
                        allAccountListCurrentUser
                    },
                });
                    
                   
            };
            return (
                <button
                    style={{ display: "block" }}
                    className={styles.PDFButton}
                    //to={redirectPath}
                    onClick={getHolderCertificate}
                >
                    <Icon icon="mi-remove-red-eye" />
                    View
                </button>
            ); 
              
        },
        [allAccountListCurrentUser, disableLossRunSubscription, history]
    );

    const handleRemoveUser = useCallback(
        (e, item) => {
            e.preventDefault();
            return modalNext
                .showConfirm({
                    title:(
                        <span className={styles.popUp}>
                            {translator(messages.removeUserMessage)}
                        </span>
                    ),
                     
                    status: 'info',
                    //icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                    cancelButtonText: commonMessages.noModel,
                })
                .then(results => {
                    if (results === 'confirm') {
                        setLoadingState(true);
                        const user = item.userName;
                        EnrollmentService.removeUser(user, authHeader)
                            .then(results => {
                                const newList = userDataVm.value.filter(
                                    item => item.userName === user
                                );
                                return setUsersListData(newList);
                            })
                            .finally(() => {
                                setLoadingState(false);
                            });
                    }
                }, _.noop);
        },
        [modalNext, EnrollmentService, history, authHeader, userDataVm]
    );

   

    const removeUser = useCallback(rowData => {
        if (rowData.userName !== auth.userInfo.email) {
            return (
                <button
                    onClick={e => handleRemoveUser(e, rowData)}
                    style={{ display: "block" }}
                    className={styles.PDFButton}
                >
                    <Icon icon="cust-trash-can-solid" />
                    Remove
                </button>
            );
        }
    });

    const getUserName = useCallback(item => {
        return `${item.name.givenName} ${item.name.familyName}`;

    });

  
    const shouldDisplayNotification = () => {
        const queryparams = new URLSearchParams(window.location.search);
        const isUserCreated = queryparams.get("created");
        if(isUserCreated === 'success') return true;
        return false;
    }

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }
    const overrides = {
        pageContainer: {
            visible: !addUser,
        },
        usersTable: {
            data: userDataVm.value,
        },
        removeUser: {
            content: removeUser,
        },
       
        newUserContainer: {
            visible: isUserValid,
        },
        userid: {
            disabled: isUserValid,
        },
       
        usersAddedInfoLabelId:{
            visible: shouldDisplayNotification()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            addnewuser: AddNewUser,
            useradmindetailspage: UserAdminDetails,
        },
        resolveCallbackMap: {
            handleAddNewUser: handleAddNewUser,
            getUserEmail,
            getDetails,
            removeUser,
            getUserName
          
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={addUserVM}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}
export default withRouter(withViewModelService(UserAdministrationPage));
